<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="page-not-found-wrapper">
      <span>Oil not Found!</span><br />
      <span>I mean, Page Not Found!</span><br />
      <button class="btn btn-primary primary-btn backpage" (click)="location.back()">Go Back To Previous Page</button>
      <img height="80%" src="assets/images/oil.gif" />
    </div>
  </div>
</div>